import React, { useMemo, useState } from 'react'
import { BACKEND_URL } from '../../Helpers/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';

import Lightbox from "yet-another-react-lightbox";
import Video from "yet-another-react-lightbox/plugins/video";
import "yet-another-react-lightbox/styles.css";

export default function AccidentItem({item, index, deleteInfo, setIdx, setIsOpenModal}) {

    const imageExt = ['jpg','jpeg','png','gif','webp','bmp','tiff','svg','ico','heic','heif'];
    const videoExt = ['mp4','webm','ogg','mov','avi','wmv','mpeg','3gp','3gpp'];

    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const slides = useMemo(() => {
    if (!item?.files?.length) return [];

    return item.files
        .map((file) => {
        const ext = file.split(".").pop().toLowerCase();
        const fullUrl = BACKEND_URL + file;

        if (imageExt.includes(ext)) {
            return { type: "image", src: fullUrl };
        }

        if (videoExt.includes(ext)) {
            return {
            type: "video",
            sources: [
                {
                src: fullUrl,
                type: `video/${ext === "mov" ? "quicktime" : ext}`,
                },
            ],
            autoPlay: false,
            preload: "metadata"
            };
        }

        return null;
        })
        .filter(Boolean);
    }, [item?.files])

    const getDate = (date) => {
        if (!date) return
        const dateNum = new Date(date)
        const formatedDate = `${dateNum.getHours() > 9 ? dateNum.getHours() : "0" + dateNum.getHours()}:${dateNum.getMinutes() > 9 ? dateNum.getMinutes() : "0" + dateNum.getMinutes()} ${dateNum.getDate() > 9 ? dateNum.getDate() : "0" + dateNum.getDate()}/${dateNum.getMonth() > 8 ? dateNum.getMonth() + 1 : "0" + (dateNum.getMonth() + 1)}/${dateNum.getFullYear()}`
        return formatedDate
    }

  return (
    <div className='p-2 border border-gray-500/40 rounded-md my-2'>
        <div className='flex justify-between'>
            <p>{getDate(item.date)}</p> 
            <p>{item.nearest_residence}</p> 
        </div>
        <p className='w-full my-2'>
            {item.accident_description}
        </p>
        {item.car_model || item.car_num || item.car_owner ? (
            <div className='grid grid-cols-3 gap-4 w-full my-2 border-t border-b border-gray-500/40 py-2'>
                {item.car_model && <p>Մեքենայի մոդել: {item.car_model}</p>}
                {item.car_num && <p className='text-center'>Մեքենայի համար: {item.car_num}</p>}
                {item.car_owner && <p className='text-end'>Մեքենայի սեփականատեր: {item.car_owner}</p>}
            </div>
        ) : null}
        {item.hurted_people.length > 0 ? (
            <div>
                <h4 className='text-center text-lg font-bold my-4'>Տուժածներ</h4>
                {item.hurted_people.map((el, index) => (
                    <table key={index} className='w-full mb-3'>
                        <tbody>
                            <tr className='w-full grid grid-cols-4 gap-4 border border-gray-500/40 p-1'>
                                <td className='border-r border-gray-500/40'>{`${el.person.rang} ${el.person.type === "haveTo" ? "" : "Պ"} ${el.person.full_name}`}</td>
                                <td className='border-r border-gray-500/40 text-center'>{el.person.conscription}</td>
                                <td className='border-r border-gray-500/40 text-center'>{`${el.person.position}/${el.responsibility}`}</td>
                                <td className='text-end'>{`${el.person.battalion.battalion_number}${el.person.battalion.battalion_name} ${el.person.company.company_number} ${el.person.platoon.platoon_number}`}</td>
                            </tr>
                            <tr className='w-full grid grid-cols-4 gap-4 border border-gray-500/40 p-1'>
                                <td className='border-r border-gray-500/40'>Ծնվել է։ {new Date(el.person.birthday).toLocaleDateString()}</td>
                                <td className='text-center border-r border-gray-500/40'>Հասցե։ {el.person.address}</td>
                                <td className='text-center border-r border-gray-500/40'>Զինկոմիսարիատ։ {el.person.mil_commissariat}</td>
                                <td className='text-end'>{el.result === "hurt" ? "Վիրավորվել է" : "Զոհվել է"}</td>
                            </tr>
                            {(el.hospitalTime && el.hospitalDate) && <tr className='w-full grid grid-cols-2 gap-4 border border-gray-500/40 p-1'>
                                <td className='border-r border-gray-500/40'>Բուժ. հաստատություն։ {el.hospital}</td>
                                <td className='text-end'>Ընդուվել է։ {el.hospitalTime + " " + el.hospitalDate}</td>
                            </tr>}
                            {el.diagnosis && <tr className='w-full grid grid-cols-1 border border-gray-500/40 p-1'>
                                <td>{el.diagnosis}</td>
                            </tr>}
                            {el.doctorsReview && <tr className='w-full grid grid-cols-1 border border-gray-500/40 p-1'>
                                <td>{el.doctorsReview}</td>
                            </tr>}
                        </tbody>
                    </table>
                ))}
            </div>
        ) : null}
        {item.files?.length > 0 && (
        <div>
          <h4 className='text-center text-lg font-bold my-2'>Ֆայլեր</h4>
          <div className='grid grid-cols-5 gap-4'>
            {item.files.map((file, i) => {
              const ext = file.split('.').pop().toLowerCase();
              const fullUrl = BACKEND_URL + file;
              const isImage = imageExt.includes(ext);

              return isImage ? (
                <img
                  key={i}
                  src={fullUrl}
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  className="rounded-md w-full h-auto cursor-pointer"
                  onClick={() => { setCurrentIndex(i); setOpen(true); }}
                />
              ) : (
                <video
                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                  key={i}
                  src={fullUrl}
                  className="rounded-md w-full h-auto cursor-pointer"
                  onClick={() => { setCurrentIndex(i); setOpen(true); }}
                />
              );
            })}
          </div>
        </div>
      )}

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={slides}
            index={currentIndex}
            plugins={[Video]}
        />
        <div className='w-full flex justify-end mt-4'>
            <div className='flex gap-3 items-center'>
                <FontAwesomeIcon icon={faPenToSquare} title="Խմբագրել" onClick={() =>{setIdx(index); setIsOpenModal(true)}} />
                <FontAwesomeIcon icon={faTrash} title="Ջնջել" onClick={() => {deleteInfo(item._id)}}/>
            </div>
        </div>
    </div>
  )
}
